import React from "react";

// Illustrated 1990s Indian classroom backdrop (non-interactive) with a live chalk board.
export const ClassroomDecor = ({ boardText = "Good Morning Students" }) => (
  <div className="pointer-events-none absolute inset-0 z-10 overflow-hidden">
    <img
      src="/school/classroom_bg.jpg"
      alt="Indian classroom"
      className="absolute inset-0 h-full w-full object-cover"
      draggable={false}
    />

    {/* live chalk writing on the (empty) blackboard region of the art */}
    <div
      className="absolute flex items-center justify-center px-2 text-center"
      style={{ left: "41%", top: "33%", width: "21%", height: "20%" }}
    >
      <span
        data-testid="classroom-board-text"
        className="font-signboard text-[10px] font-bold leading-tight text-[#eaf3e6] sm:text-sm"
        style={{ textShadow: "0 0 6px rgba(255,255,255,0.28)", overflowWrap: "anywhere" }}
      >
        {boardText || "…"}
      </span>
    </div>

    {/* soft gentle vignette (art is already flat/illustrated) */}
    <div className="absolute inset-0" style={{ boxShadow: "inset 0 0 70px rgba(60,40,10,0.12)" }} />
  </div>
);
